import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { LandingNav } from "../website/LandingNav.jsx";
import { LandingFooter } from "../website/LandingFooter.jsx";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) return;
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname, location.hash]);

  return null;
};

const MainLayout = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <ScrollToTop />
      <LandingNav />
      <main className="flex-1">
        <Outlet />
      </main>
      <LandingFooter />
    </div>
  );
};

export default MainLayout; 